<template lang="pug">
  #cse.gcse-search
</template>

<style lang="scss">
.gsc-search-box{
  line-height: 0;
  height: 40px;
}

.gsc-tabsArea, .gsc-orderby-container{
  display: none;
}

.gsc-adBlock{
  display: none !important;
}

.gs-result{
  border-left: 3px solid rgba($color-blue-dark, 0.4);
  padding-left: 15px;
  &:hover{
    border-color: rgba($color-blue-dark, 0.6);
  }
}

.gs-no-results-result .gs-snippet, .gs-error-result .gs-snippet{
  margin: 0 !important;
}

.gs-result .gs-title, .gs-result .gs-title *{
  text-decoration: none !important;
}

.gsc-results{
  width: 100% !important;
}

.gs-no-results-result{
  border: 0;
  padding: 0;
  margin: 20px 0;
  .gs-snippet{
    padding: 15px !important;
    // font-family: $font_open, arial !important;
    background-color: #f2dede !important;
    border-color: #ebccd1 !important;
    color: #a94442 !important;
    margin: 0;
    font-size: 14px !important;
    border-radius: 4px !important;
  }
}

a.gs-title{
  text-decoration: none !important;
  text-decoration-line: none !important;
  text-decoration-style: none !important;
  text-decoration-color: none !important;
  color: $color-blue-dark !important;
  font-weight: bolder;
  b{
    text-decoration: none !important;
    color: $color-blue-dark !important;

    &:hover{
      color: rgba($color-blue-dark, 0.8) !important;
    }
  }

  &:hover{
    color: rgba($color-blue-dark, 0.8) !important;
  }
}

.gs-webResult div.gs-visibleUrl, .gs-imageResult div.gs-visibleUrl{
  color: $color-green-dark !important;
  margin-top: 5px;
}

.gs-webResult .gsc-thumbnail-inside, .gs-result .gsc-thumbnail-inside{
  margin: 0;
  padding: 0;
}

.gsc-url-top{
  padding: 0 !important;
}

.gsc-table-result{
  .gsc-table-cell-thumbnail, .gsc-thumbnail{
    display: none;
  }
}

.cse .gsc-control-cse, .gsc-control-cse{
  padding: 0 !important;
}

.cse .gsc-control-cse, .gsc-control-cse{
  border: 0 !important;
}

.gcsc-branding{
  display: none !important;
}

.cse .gsc-search-button input.gsc-search-button-v2, input.gsc-search-button-v2{
  width: 60px !important;
  height: 25px !important;
  margin-top: 0px !important;
  border-radius: 5px !important;
}

.gsc-input-box{
  padding-bottom: 5px;
  // background-color: #F2F7F7 !important;
  // border-radius: 0 !important;
  border-color: #c9dddd;
  height: 35px !important;
  // height: auto !important;
  background-color: #F2F2F2 !important;
  border-radius: 7px !important;
  padding: 3px 0;

  .gsc-input{
    background-color: #F2F2F2 !important;
    // background-color: #F2F7F7 !important;
    color: $color-grey-dark !important;
  }

  .gscb_a{
    font-size: 15px;
    font-weight: bolder;
    color: $color-grey-dark !important;
  }

  &:hover{
    border: 1px solid #D9D9D9 !important;
  }
}

td.gsc-search-button {
  button.gsc-search-button-v2 {
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    padding: 11px 23px !important;
    border: 0 !important;
    background-color: $color-blue-dark !important;
    height: 35px !important;
    border-radius: 7px !important;
  }
}

#gs_tti50{
  input{
    // font-family: $font_open !important;
    font-size: 14px !important;
  }
}

// Thumbnail das notícias
.gsc-table-cell-thumbnail{
  display: none;
}

.gsc-search-box .gsc-input>input{
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075) !important;
  transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s !important;
}

.gsc-search-box .gsc-input>input:hover, .gsc-input-box-hover {
  border-top-color: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.gsc-search-box .gsc-input>input:focus, .gsc-input-box-focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.gsc-cursor-box{
  margin: 40px 0 !important;
  text-align: center !important;
  font-size: 14px;
  display: flex !important;
  justify-content: center;
}

.gsc-cursor-page{
  font-family: 'Dosis', arial !important;
  color: #828282 !important;
  padding: 6px 12px !important;
  font-size: 16px !important;
  border: 1px solid #ddd !important;
  min-width: 25px !important;
  flex: 1 1 auto !important;
  margin: 0 0 0 -1px !important;

  &:first-child{
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }
  &:last-child{
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }

  &:hover{
    // color: $color-blue-dark !important;
    background-color: #eee !important;
  }
}

.gsc-results .gsc-cursor-box .gsc-cursor-page:hover{
  text-decoration: none !important;
}

.gsc-cursor-current-page{
  color: white !important;
  font-weight: normal !important;
  background-color: $color-blue-dark !important;
  &:hover{
    // color: $color-blue-dark !important;
    background-color: $color-blue-dark !important;
  }
}


/* Wrapper for a result. */
.gsc-webResult .gsc-result {
  margin: 0 !important;
  padding: 0 !important;
  border-bottom: 0px !important;
  margin-bottom: 20px !important;
}

.gsc-above-wrapper-area {
  border-bottom: 0px !important;
  padding: 0 !important;
}

.gsc-result-info {
  font-size: 12px !important;
  padding: 0px !important;
  padding-top: 8px !important;
  padding-bottom: 10px !important;
}

.gsc-refinementsArea {
  margin-top: 0;
  padding-bottom: 4px;
  padding-top: 10px;
}

.gs-spelling{
  // font-family: $font_open, arial !important;
  border: 0 !important;
  padding: 0 !important;
  margin-bottom: -5px !important;

  a{
    text-decoration: none !important;
    color: $color-green-dark !important;

    &:hover{
      color: rgba($color-green-dark, 0.8) !important;
    }
  }
}

.gsc-webResult.gsc-result{
  border: 0 !important;
}
</style>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// BaseGoogleSearch.vue?63dff3bc